// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M3 6.75C2.17 6.75 1.5 6.08 1.5 5.25V3C1.5 2.17 2.17 1.5 3 1.5H5.25C6.08 1.5 6.75 2.17 6.75 3',
  'M6.88 10.63C6.05 10.63 5.38 9.95 5.38 9.13V6.88C5.38 6.05 6.05 5.38 6.88 5.38H9.13C9.95 5.38 10.63 6.05 10.63 6.88',
  'M10.75 9.25H13C13.83 9.25 14.5 9.92 14.5 10.75V13C14.5 13.83 13.83 14.5 13 14.5H10.75C9.92 14.5 9.25 13.83 9.25 13V10.75C9.25 9.92 9.92 9.25 10.75 9.25Z',
];
